import { Section, Query, ListPlans, GridList } from '@wolfdanepug/common-react'
import PetProfileCard from '../../../components/pet-profile/PetProfileCard'
import { PageContext } from '../../../context/page'
import { useContext, useEffect } from 'react'

export default function Pets() {
	const { setPage } = useContext(PageContext)

	useEffect(() => {
		setPage({
			title: 'Pets',
			description: 'Manage your pet profiles'
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<>
			<Section>
				<Query
					doc={ListPlans}
					component={GridList}
					componentProps={{
						component: PetProfileCard,
						spacing: 3,
						itemsPerRow: 3
					}}
				/>
			</Section>
		</>
	)
}
